import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 28, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function MaskLine({ children, delay = 0, className = "" }) {
  return (
    <span className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block will-change-transform"
        initial={{ y: "115%" }}
        animate={{ y: 0 }}
        transition={{ duration: 1, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function SectionHead({ eyebrow, title, index, sub }) {
  return (
    <Reveal className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-12 sm:mb-16">
      <div className="max-w-2xl">
        <p className="font-mono text-xs tracking-[0.3em] uppercase text-gold mb-4">{eyebrow}</p>
        <h2 className="font-display font-extrabold uppercase tracking-tight leading-[0.95] text-3xl sm:text-5xl lg:text-6xl">
          {title}
        </h2>
        {sub ? <p className="mt-4 text-slate-400 max-w-xl text-sm sm:text-base">{sub}</p> : null}
      </div>
      <span className="font-mono text-xs text-white/30 tracking-[0.25em] shrink-0">{index}</span>
    </Reveal>
  );
}
